import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchInvoiceSummary, InvoiceSummaryResponse } from '../../api/invoicesummary';

// Async thunk for fetching invoice summary
export const fetchInvoiceSummaryAsync = createAsyncThunk(
  'invoiceSummary/fetchInvoiceSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchInvoiceSummary();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch invoice summary');
    }
  }
);

// Invoice summary state interface
export interface InvoiceSummaryState {
  summaryData: InvoiceSummaryResponse | null;
  loading: boolean;
  error: string | null;
  message: string | null;
}

// Initial state
const initialState: InvoiceSummaryState = {
  summaryData: null,
  loading: false,
  error: null,
  message: null,
};

// Invoice summary slice
const invoiceSummarySlice = createSlice({
  name: 'invoiceSummary',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
    clearSummaryData: (state) => {
      state.summaryData = null;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch invoice summary
      .addCase(fetchInvoiceSummaryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(fetchInvoiceSummaryAsync.fulfilled, (state, action: PayloadAction<InvoiceSummaryResponse>) => {
        state.loading = false;
        state.summaryData = action.payload;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(fetchInvoiceSummaryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.summaryData = null;
        state.message = null;
      });
  },
});

// Export actions
export const { clearError, clearMessage, clearSummaryData } = invoiceSummarySlice.actions;

// Export reducer
export default invoiceSummarySlice.reducer;